<template>
  <div :style="pageLayoutStyle" :class="isFull ? 'full' : ''" :id="domId">
    <div class="search">
      <div class="search-top-box">
        <div class="search-box">
          <span style="display: inline; margin-right: 10px;font-weight: bolder;flex-shrink: 0;" v-if="title">
            {{ i18nConfig(title) }}
          </span>
          <slot name="topSearchBefore"></slot>
          <!-- 顶部查询条件,封装到 gljy-query-where 组件中渲染,后续可复用 -->
          <gljy-query-where :fields="queryWhereField" :queryWhere="queryWhere"
            :topShowWhereFieldNumber="topShowWhereFieldNumber" :isBottom="false"
            @field-change="queryWhereFieldChange">
            <template #topSearchItemBefore="{ field, index }">
              <slot name="topSearchItemBefore" :field="field" :index="index"></slot>
            </template>
            <template #topSearchItemAfter="{ field, index }">
              <slot name="topSearchItemAfter" :field="field" :index="index"></slot>
            </template>
          </gljy-query-where>
          <slot name="topSearchAfter"></slot>
          <gljy-button @click="queryDataList({}, false)" v-if="queryWhereField.length > 0"
            style="backgroundcolor: #f5f5f5; width: 40px; margin-right: 0px">
            <template #icon>
              <el-icon>
                <Search />
              </el-icon>
            </template>
          </gljy-button>
          <gljy-button @click="restQueryWhere()" v-if="queryWhereField.length > 0"
            style="backgroundcolor: #f5f5f5; width: 40px; margin-right: 0px">
            <template #icon>
              <el-icon>
                <RefreshRight />
              </el-icon>
            </template>
          </gljy-button>
          <gljy-button @click="flag = !flag" v-if="isShowfilterIcon()"
            style="backgroundcolor: #f5f5f5; width: 40px; margin-right: 0px">
            <template #icon>
              <el-icon>
                <Filter />
              </el-icon>
            </template>
          </gljy-button>
        </div>
        <el-space class="icons">
          <slot name="searchTools"></slot>
          <svg-icon class="icon-show" v-if="isShowTools" :icon-class="isFull ? 'exit-fullscreen' : 'fullscreen'"
            @click="openFull()" style="cursor: pointer;" />
          <el-popover :title="i18nConfig('密度')" trigger="click" placement="bottom" v-if="isShowTools && !isFull">
            <template #reference>
              <el-icon style="cursor: pointer;">
                <Operation />
              </el-icon>
            </template>
            <el-menu :default-active="size" mode="vertical">
              <el-menu-item @click="size = 'large'" index="large">{{ i18nConfig('最大尺寸') }}</el-menu-item>
              <el-menu-item @click="size = 'default'" index="default">{{ i18nConfig('中等尺寸') }}</el-menu-item>
              <el-menu-item @click="size = 'small'" index="small">{{ i18nConfig('最小尺寸') }}</el-menu-item>
            </el-menu>
          </el-popover>
          <el-popover trigger="click" placement="bottom" popper-class="overlayStyle" v-if="isShowTools && !isFull">
            <template #reference>
              <el-icon style="cursor: pointer;">
                <Setting />
              </el-icon>
            </template>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span>{{ i18nConfig('列设置') }}</span>
              <div>
                <el-icon style="cursor: pointer;" @click="saveColumnSetting">
                  <MessageBox />
                </el-icon>
                <span>&nbsp;</span>
                <el-icon style="cursor: pointer;" @click="restColumnSetting">
                  <RefreshRight />
                </el-icon>
              </div>
            </div>
            <div class="Column-setup">
              <draggable :list="checkboxColumns" animation="300" itemKey="dataIndex" @end="onEnd">
                <template #item="{ element: item }">
                  <div class="setup-item" :key="item.dataIndex">
                    <gljy-checkbox style="margin-left: 0px" :disabled="disabledCheckboxColumns(item)"
                      @change="(value) => checkedChange(item.dataIndex, value)" v-model="item.checked"
                      :value="item.dataIndex">
                      <span>{{ item.title }}</span>
                    </gljy-checkbox>
                  </div>
                </template>
              </draggable>
            </div>
          </el-popover>
          <slot name="footIcon"></slot>
        </el-space>
      </div>
      <div class="search-bottom-box">
        <div v-show="flag">
          <slot name="searchBefore"></slot>
          <!-- 底部查询条件,封装到 gljy-query-where 组件中渲染,后续可复用 -->
          <gljy-query-where :fields="queryWhereField" :queryWhere="queryWhere"
            :topShowWhereFieldNumber="topShowWhereFieldNumber" :isBottom="true"
            @field-change="queryWhereFieldChange">
            <template #searchItemBefore="{ field, index }">
              <slot name="searchItemBefore" :field="field" :index="index"></slot>
            </template>
            <template #searchItemAfter="{ field, index }">
              <slot name="searchItemAfter" :field="field" :index="index"></slot>
            </template>
          </gljy-query-where>
          <slot name="searchAfter"></slot>
        </div>
      </div>
    </div>
    <div class="pb10" style="display: flex; justify-content: space-between; align-items: center;">
      <div style="flex:1">
        <slot name="tableUp"></slot>
      </div>
      <gljy-button v-if="isShowBtn" class="closeBtns"
        style="float: right; font-size: 13px; padding: 1px 8px;height: 28px; border-color: #2E54EC; color: #2E54EC;"
        @click="closeClick"><i :class="newShowTable ? 'iconfont icon-shouqianniu' : 'iconfont icon-gengduoanniu'"
          style="padding-right: 5px; font-size: 13px"></i>{{ closeTitle }}
      </gljy-button>
    </div>
    <el-table v-if="ifShowTable" :border="border" :data="dataSource ? dataSource : newDataSource" :size="size"
      :row-key="rowKey" @row-click="rowClick" :rowClassName="rowClassName ? rowClassName : newRowClassName"
      :height="height" bordered v-loading="loading" @expand="expand" @expandedRowsChange="expandedRowsChange"
      @resizeColumn="resizeColumn" :default-expand-all="defaultExpandAll" @selection-change="handleSelectionChange"
      :show-summary="showSummary" @row-dblclick="rowDblclick" :row-style="rowStyle" ref="tableRef">
      <template v-if="rowSelection">
        <el-table-column type="selection" :selectable="rowSelection ? rowSelection.selectable : undefined" width="55"
          align="center" />
      </template>
      <!-- 列渲染抽离到 table-column 子组件:支持 columnItem.children 嵌套配置多级表头 -->
      <table-column v-for="columnItem in newColumns" :key="columnItem.dataIndex" :columnItem="columnItem"
        :pagination="newPagination">
        <!-- 把外部传入的 bodyCell 插槽透传给子组件,递归过程中所有叶子列都能拿到同一份插槽 -->
        <template #bodyCell="slotProps">
          <slot name="bodyCell" v-bind="slotProps" />
        </template>
      </table-column>
    </el-table>
    <template v-if="newPagination">
      <div class="pagination-box" v-show="newPagination.total > 0">
        <el-pagination :page-sizes="newPagination.pageSizeOptions" size="small" :layout="newPagination.layout"
          :total="newPagination.total" v-model:current-page="newPagination.current"
          v-model:page-size="newPagination.pageSize" @change="queryDataList()" />
      </div>
    </template>
  </div>
</template>
<script>
import { checkPermi } from '@/utils/permission.js';
import { i18nConfig } from '@/utils/ruoyi';
import tableSlot from "./table-slot.vue";
import gljyQueryWhere from "./gljy-query-where.vue";
import tableColumn from "./table-column.vue";
import useAppStore from '@/store/modules/app';
import useUserStore from '@/store/modules/user'
import { useRouter } from "vue-router";
import { reactive, toRefs, onMounted, onActivated, useSlots, watch, onBeforeMount, nextTick, getCurrentInstance } from "vue";
import system from "@/api/system/common.js";
export default {
  name: "gljy-table",
  components: {
    tableSlot,
    gljyQueryWhere,
    // 列渲染子组件(支持 columnItem.children 多级表头,内部递归引用自身)必须用同步 import,
    // 异步 import 会导致递归自引用失败,Vue 报 Failed to resolve component: table-column
    tableColumn,
  },
  // 对外暴露的自定义事件
  emits: ["rowDblclick", "rowClick", "expand", "expandedRowsChange", "resizeColumn", "resultQueryData", "restQueryWhere"],
  // 父组件可以传入参数集合
  props: {
    // table组件的唯一标识,主要适用与一个页面多个table组件的情况下,需要设置table的id,这样才能保证table列设置显示和隐藏不会出问题
    tableId: {
      type: String,
      default: "table",
    },
    // 标题
    title: {
      type: String,
      default: "",
    },
    // 是否显示工具栏
    isShowTools: {
      type: Boolean,
      default: true,
    },
    // 是否显示折叠按钮
    isShowBtn: {
      type: Boolean,
      default: false,
    },
    // 行唯一键
    rowKey: {
      type: [String, Function],
      default: "id",
    },
    // 是否可拖动列宽
    isResizable: {
      type: Boolean,
      default: true,
    },
    // 列表列---扩展属性 hasPermi:['outsExamineNotice:add'] ---当前列需要指定的权限才显示
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 数据源
    dataSource: {
      type: Array,
      default: () => {
        return undefined;
      },
    },
    // 选择行配置 ,配置false 则隐藏行勾选框
    rowSelection: {
      type: [Object, Boolean],
      default: () => {
        return false;
      }
    },
    // 行类名设置
    rowClassName: {
      type: Function,
    },
    // 配置需要翻译的字典属性
    dictConfig: {
      type: Object,
      default: {},
    },
    // 查询条件字段
    /*
      type:可选 "String 或 select 或 hsSelect 或 datePicker " defaultValue: 默认值 style: 配置控件样式
      isHidden: false 是否隐藏(默认不隐藏), 配置为true的时候,查询条件隐藏
      isNotAutoQuery: false 值改变的时候,是否不自动查询数据, 默认为false, 为true时,值改变,不自动查询数据
      {fieldName: "constractorId", type: "select", placeholder: "供应商", defaultValue:"",
        style:{width:'20px'},
        下拉框设置选项
        selectSetting:{
          // 指定显示的值
          fieldNames:{label:'label', value:'value'},
          // options type 为 select 时有效
          options:[
            {id:"456456465", constractorName":"xxxxxx" }
          ],
          url:"/xxx/xxx", typ为queryUrl时有效
          queryFunction: function, // 此传入查询函数--type为queryFunction时有效
          extendQueryWhere:  {
            methods:"get", //默认post请求--typ为queryUrl时有效
            xxx:"xxx" // 其他请求参数
          }
      ]}

    */
    queryWhereField: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 上面显示查询条件数量
    topShowWhereFieldNumber: {
      type: Number,
      default: 4,
    },
    // 扩展查询条件
    extendQueryWhere: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 查询之前的判断 -- 函数返回false,不执行查询 返回true执行查询, 组件会给次此函数传值最全的查询条件对象
    queryBeforeJudge: {
      type: Function,
      default: () => {
        return () => {
          return true;
        };
      },
    },
    // 查询函数
    queryFunction: {
      type: Function,
      default: () => {
        return () => { };
      },
    },
    // 分页配置--false就不显示分页
    pagination: [Object, Boolean],
    // 列表滚动
    height: {
      type: [String, Number],
      default: () => {
        return "calc(100% - 80px)";
      },
    },
    // 是否显示工具栏列排序是否开启
    isOpenToolsColumnsOrderBy: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    defaultExpandAll: Boolean, // 是否默认展开所有
    isClearAxiosToken: {
      type: Boolean,
    },
    showTable: {
      type: Boolean,
      default: true,
    },
    pageLayoutStyle: {
      type: [Object, String],
      default: "width: 100%; margin: 0;padding: 0px 10px;height: 100%; display: flex; flex-direction: column;",
    },
    rowStyle: Function,
    showSummary: Boolean, // 是否显示合计行
    border: {
      type: Boolean,
      default: true,
    }
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    const userStore = useUserStore()
    const appStore = useAppStore();
    const router = useRouter();
    const slots = useSlots();
    const currentPath = router.currentRoute.value.path;
    const domId = computed(() => {
      return currentPath?.replace("/", "-") + props.tableId;
    })
    const tableRef = ref();
    let datas = reactive({
      isFull: false,
      ifShowTable: true,
      isCache: false,
      isSlot: false,
      checkboxColumns: [],
      newColumns: [],
      size: "small",
      flag: false,
      selectedRows: [],
      selectedRowKeys: [],
      currentSelectId: "",
      loading: false,
      closeTitle: "展开", //显示折叠状态
      queryWhere: {},
      newDataSource: [], // 列表数据源
      listData: [],
      newPagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        simple: false,
        showSizeChanger: true,
        showQuickJumper: true,
        layout: "total, sizes, prev, pager, next, jumper, ->, slot",
        showTotal: (total) => {
          return `总条数:${total}条`;
        },
        pageSizeOptions: ["10", "20", "50", "100", "500", "1000"],
      },
      i18nConfig: i18nConfig
    });
    onBeforeMount(() => {
      methods.initDictConfig();
    });
    onMounted(() => {
      methods.fullListen();
      if (props.isShowBtn) {
        if (datas.closeTitle == "展开") {
          datas.newShowTable = false;
        } else {
          datas.newShowTable = true;
        }
      }
      if (slots.searchBefore || slots.searchAfter) {
        datas.isSlot = true;
      }
      // 构造查询条件
      props.queryWhereField.forEach((item) => {
        if (item.type == "gljyDatePicker" && (item.prickerSetting.type === "daterange" || item.prickerSetting.type === "datetimerange")) {
          const prickerSetting = item.prickerSetting;
          if (prickerSetting.startDate) {
            datas.queryWhere[prickerSetting.startDate.fieldName] = prickerSetting.startDate.defaultValue;
          }
          if (prickerSetting.endDate) {
            datas.queryWhere[prickerSetting.endDate.fieldName] = prickerSetting.endDate.defaultValue;
          }
          datas.queryWhere[item.fieldName] = [prickerSetting.startDate.defaultValue, prickerSetting.endDate.defaultValue];
        } else {
          datas.queryWhere[item.fieldName] = item.defaultValue;
        }
      });

      if (props.pagination != null && props.pagination != undefined) {
        if (typeof props.pagination == "boolean") {
          datas.newPagination = props.pagination;
        } else {
          Object.assign(datas.newPagination, props.pagination);
        }
      }
      columnSetupMethods.initCheckboxColumns();
      columnSetupMethods.initSetColumns();
      columnSetupMethods.bathColumnOrderBy();
    });

    watch(
      () => [...props.columns],
      (now, old) => {
        columnSetupMethods.initCheckboxColumns();

        columnSetupMethods.initSetColumns();

        columnSetupMethods.bathColumnOrderBy();
      }
    );

    watch(
      () => props.showTable,
      () => {
        datas.newShowTable = props.showTable;
      }
    );

    watch(() => props.defaultExpandAll, () => {
      datas.ifShowTable = false;
      nextTick(() => {
        datas.ifShowTable = true;
      })
    }
    );

    watch(() => appStore.locale, () => {
      setTimeout(() => {
        columnSetupMethods.initCheckboxColumns();

        columnSetupMethods.initSetColumns();

        columnSetupMethods.bathColumnOrderBy();
      })
    })
    watch(() => appStore.i18nLanguageConfig, () => {
      setTimeout(() => {
        columnSetupMethods.initCheckboxColumns();

        columnSetupMethods.initSetColumns();

        columnSetupMethods.bathColumnOrderBy();
      })
    })

    const methods = {
      openFull() {
        const isFull = datas.isFull;
        const docElm = document.getElementById(domId.value);
        if (!isFull && docElm) {
          // 全屏
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen();
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen();
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen();
          } else if (docElm.msRequestFullscreen) {
            docElm.msRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
        datas.isFull = !isFull;
      },
      // 绑定监听事件
      fullListen() {
        let screen = document.getElementById(domId.value);
        if (screen && screen.requestFullscreen) {
          document.addEventListener("fullscreenchange", () => {
            if (methods.getFullscreenElement() == null) {
              datas.isFull = false;
            }
          })
        }
      },
      // 获取全屏状态
      getFullscreenElement() {
        return (
          document['fullscreenElement'] ||
          document['mozFullScreenElement'] ||
          document['msFullScreenElement'] ||
          document['webkitFullscreenElement'] || null
        );
      },
      // 查询条件变化事件
      queryWhereFieldChange(field) {
        if (field.isNotAutoQuery) return;
        methods.queryDataList({}, true);
      },
      getQueryWhere(whereParam) {
        if (props.extendQueryWhere) {
          Object.keys(props.extendQueryWhere).forEach((key) => {
            datas.queryWhere[key] = props.extendQueryWhere[key];
          });
        }

        if (props.queryWhereField) {
          Object.values(props.queryWhereField).forEach((field) => {
            if (field.type == "checkbox") {
              datas.queryWhere[field.fieldName] = Number(datas.queryWhere[field.fieldName])
            }
          });
        }

        if (whereParam) {
          Object.keys(whereParam).forEach((key) => {
            datas.queryWhere[key] = whereParam[key];
          });
        }
        return datas.queryWhere;
      },
      queryDataList(whereParam, isFlush, isClear) {
        if (isClear) {
          datas.queryWhere = {};
        }
        const queryWhere = methods.getQueryWhere(whereParam);
        // 添加分页参数
        datas.queryWhere.pageNum = datas.newPagination.current;
        datas.queryWhere.pageSize = datas.newPagination.pageSize;
        if (!props.queryBeforeJudge(datas.queryWhere)) {
          return false;
        }
        if (isFlush && props.pagination != false) {
          datas.newPagination.current = 1;
        }
        datas.loading = true;
        const pagination = { pageNum: datas.newPagination.current, pageSize: datas.newPagination.pageSize };
        props.queryFunction(datas.queryWhere, pagination)
          .then((res) => {
            context.emit("resultQueryData", res);
            if (res.code == 200) {
              datas.loading = false;
              if (res.rows) {
                datas.newDataSource = res.rows;
              } else if (res.data) {
                datas.newDataSource = res.data;
              }
              if (datas.newPagination)
                datas.newPagination.total = res.total;
            } else if (res.code == 40001) {
              datas.loading = false;
              datas.newDataSource = [];
              if (datas.newPagination) datas.newPagination.total = 0;
            } else {
              datas.loading = false;
              datas.newDataSource = [];
              if (datas.newPagination) datas.newPagination.total = 0;
            }
          })
          .catch((error) => {
            console.log("table查询数据错误", error);
            datas.loading = false;
          });
      },
      restQueryWhere() {
        Object.keys(datas.queryWhere).forEach((item) => {
          const field = props.queryWhereField.find(
            (field) => field.fieldName == item
          );
          if (field != null && field.defaultValue !== null && field.defaultValue !== undefined) {
            datas.queryWhere[item] = field.defaultValue;
          } else {
            datas.queryWhere[item] = undefined;
          }
        });
        context.emit("restQueryWhere");
        methods.queryDataList({}, true);
      },
      newRowClassName(_record, index) {
        let currentSelectId = "";
        if (typeof props.rowKey == "function") {
          currentSelectId = props.rowKey(_record);
        } else {
          currentSelectId = _record[props.rowKey];
        }
        if (currentSelectId == datas.currentSelectId) {
          return "rowactive";
        } else if (index % 2 === 1) {
          return "table-striped";
        } else {
          return "";
        }
      },
      tableCharge(pagination, filters, sorter, { currentDataSource }) {
        const params = {};
        if (sorter.column) {
          params.sortFields = sorter.field;
          params.sortDirections = sorter.order;
        } else {
          params.sortFields = undefined;
          params.sortDirections = undefined;
        }
        if (pagination.current != datas.newPagination.current) {
          datas.newPagination.current = pagination.current;
        }
        if (pagination.pageSize != datas.newPagination.pageSize) {
          datas.newPagination.pageSize = pagination.pageSize;
        }
        methods.queryDataList(params);
      },
      async initDictConfig() {
        let categoryArr = [];
        for (const index in props.dictConfig) {
          const dictConfig = props.dictConfig[index];
          categoryArr.push(dictConfig.dictCategoryType);
        }
        if (categoryArr == null || categoryArr.length <= 0) return;
        const res = await system.queryCategoryDictionaryValueMap(
          categoryArr.join(",")
        );
        if (res.code == 200) {
          const resData = res.data;
          for (const index in props.dictConfig) {
            const dictConfig = props.dictConfig[index];
            props.dictConfig[index].value =
              resData[dictConfig.dictCategoryType];
          }
        }
      },
      disabledCheckboxColumns(checkboxColumn) {
        const checkedColumns = datas.checkboxColumns.filter(
          (item) => item.checked
        );
        if (checkedColumns != null && checkedColumns.length == 1) {
          if (checkboxColumn.checked) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      // 行点击事件
      rowClick(row, column, event) {
        context.emit("rowClick", row, column, event);
      },
      // 是否显示过滤图标
      isShowfilterIcon() {
        if (datas.isSlot > 0) {
          return true;
        }
        const topShowWhereFieldNumber = props.topShowWhereFieldNumber;
        const queryWhereField = props.queryWhereField;
        if (queryWhereField.length > topShowWhereFieldNumber) {
          for (
            let i = topShowWhereFieldNumber;
            i < queryWhereField.length;
            i++
          ) {
            const item = queryWhereField[i];
            if (item.isHidden == null || item.isHidden == false) {
              return true;
            }
          }
        }
        return false;
      },
      expand(expanded, record) {
        context.emit("expand", expanded, record);
      },
      expandedRowsChange(expandedRows) {
        context.emit("expandedRowsChange", expandedRows);
      },
      resizeColumn(width, column) {
        column.width = width;
        context.emit("resizeColumn", width, column);
      },
      // 多选事件
      handleSelectionChange(val) {
        const keys = val.map(item => item[props.rowKey]);
        datas.selectedRows = val;
        datas.selectedRowKeys = keys;
        if (props.rowSelection?.onChange) {
          props.rowSelection.onChange(keys, val);
        }
      },
      rowDblclick(row, column, event) {
        context.emit("rowDblclick", row, column, event)
      },
      // 点击折叠按钮隐藏表格内容
      closeClick() {
        if (datas.closeTitle == "展开") {
          datas.newShowTable = true;
          datas.closeTitle = "折叠";
        } else {
          datas.closeTitle = "展开";
          datas.newShowTable = false;
        }
      },
    };

    onActivated(() => {
      const isUpdate = router.currentRoute.value.query?.isUpdate;
      if (!props.dataSource && datas.isCache && isUpdate) {
        methods.queryDataList({}, false);
      }
      datas.isCache = true;
    });

    const columnSetupMethods = {
      // 初始化table列
      initCheckboxColumns() {
        if (props.columns == null || props.columns.length == 0) return;
        let columnsSetUpSetting = JSON.parse(
          localStorage.getItem("columnsSetUpSetting")
        );
        let checkboxColumns = columnsSetUpSetting
          ? columnsSetUpSetting[`${currentPath}-${props.tableId}`]
          : [];
        if (!checkboxColumns) checkboxColumns = [];
        if (
          columnsSetUpSetting &&
          checkboxColumns.length != props.columns.length
        ) {
          delete columnsSetUpSetting[`${currentPath}-${props.tableId}`];
          localStorage.setItem(
            "columnsSetUpSetting",
            JSON.stringify(columnsSetUpSetting)
          );
          checkboxColumns = [];
        }
        let newColumns = [];
        const permissions = userStore.permissions;
        if (checkboxColumns != null && checkboxColumns.length > 0) {
          props.columns.forEach((item) => {
            console.log("item.i18nTitle", item.i18nTitle, item.title)
            if (!item.i18nTitle) item.i18nTitle = item.title;
            item.title = i18nConfig(item.i18nTitle);
            // 判断列是否加了溢出省略,没有的话,默认加上去
            if (item.ellipsis == null || item.ellipsis == undefined) {
              item.ellipsis = true;
            }
            // 判断列是否可以拖动
            if (props.isResizable) {
              let width = item.width;
              if (typeof width == "string") {
                item.width = parseInt(width.replace("px", ""));
              } else if (width == null) {
                item.width = 100;
              }
              if (!item.maxWidth) item.maxWidth = 3 * item.width;
              if (!item.minWidth) item.minWidth = item.width / 2;
              item.resizable = true;
            }
            // 判断列是否是隐藏
            const isHidden = item.isHidden;
            if (isHidden == true || isHidden == "true") return;
            // 判断列是否需要权限
            const hasPermi = item.hasPermi;
            if (hasPermi != null && hasPermi.length > 0) {
              if (!checkPermi(hasPermi)) return;
            }
            newColumns.push(item);
            if (item.checked == undefined) {
              item.checked = true;
            }
          });
        } else {
          props.columns.forEach((item) => {
            if (!item.i18nTitle) item.i18nTitle = item.title;
            item.title = i18nConfig(item.i18nTitle);
            // 判断列是否加了溢出省略,没有的话,默认加上去
            if (
              (item.ellipsis == null || item.ellipsis == undefined) && item.i18nTitle != "操作"
            ) {
              item.ellipsis = true;
            }
            // 判断列是否可以拖动
            if (props.isResizable) {
              let width = item.width;
              if (typeof width == "string") {
                item.width = parseInt(width.replace("px", ""));
              } else if (width == null) {
                item.width = 100;
              }
              if (!item.maxWidth) item.maxWidth = 3 * item.width;
              if (!item.minWidth) item.minWidth = item.width / 2;
              item.resizable = true;
            }
            // 判断列是否是隐藏
            const isHidden = item.isHidden;
            if (isHidden == true || isHidden == "true") return;
            // 判断列是否需要权限
            const hasPermi = item.hasPermi;
            if (hasPermi != null && hasPermi.length > 0) {
              if (!checkPermi(hasPermi)) return;
            }
            newColumns.push(item);
            if (item.checked == undefined) {
              item.checked = true;
            }
            checkboxColumns.push(item);
          });
        }
        datas.checkboxColumns = checkboxColumns;
        datas.newColumns = newColumns;
      },
      // 初始化设置table列隐藏
      initSetColumns() {
        const columnsSetting = JSON.parse(
          localStorage.getItem("columnsSetting")
        );
        if (columnsSetting) {
          const currentColumnsSetting =
            columnsSetting[`${currentPath}-${props.tableId}`];
          if (!currentColumnsSetting) return;
          currentColumnsSetting.forEach((currentItem) => {
            const dataIndex = currentItem.dataIndex;
            datas.checkboxColumns.forEach((item) => {
              if (item.dataIndex == dataIndex) {
                item.checked = false;
              }
            });
            for (let i = 0; i < datas.newColumns.length; i++) {
              if (datas.newColumns[i].dataIndex == dataIndex) {
                datas.newColumns.splice(i, 1);
                i--;
              }
            }
          });
          columnSetupMethods.bathColumnOrderBy();
        }
      },
      // 设置table列显示或隐藏
      checkedChange(dataIndex, checked) {
        const key = dataIndex;
        if (checked) {
          const checkedList = datas.checkboxColumns.filter(
            (item) => item.checked
          );
          const index = checkedList.findIndex((item) => item.dataIndex == key);
          const findItem = props.columns.find((item) => item.dataIndex == key);
          datas.newColumns.splice(index, 0, findItem);
        } else {
          datas.newColumns.forEach((item, index) => {
            if (item.dataIndex == key) {
              datas.newColumns.splice(index, 1);
              return;
            }
          });
        }
        let columnsSetting = JSON.parse(localStorage.getItem("columnsSetting"));
        if (!columnsSetting) columnsSetting = {};
        let checkedColumns = [];
        datas.checkboxColumns.forEach((item) => {
          if (!item.checked) {
            checkedColumns.push(item);
          }
        });
        columnsSetting[`${currentPath}-${props.tableId}`] = checkedColumns;
        localStorage.setItem("columnsSetting", JSON.stringify(columnsSetting));

        let columnsSetUpSetting = JSON.parse(
          localStorage.getItem("columnsSetUpSetting")
        );
        if (!columnsSetUpSetting) columnsSetUpSetting = {};
        columnsSetUpSetting[`${currentPath}-${props.tableId}`] =
          datas.checkboxColumns;
        localStorage.setItem(
          "columnsSetUpSetting",
          JSON.stringify(columnsSetUpSetting)
        );
      },
      // table列向上移动事件
      columnSetupUpOrDow(item, index, type) {
        const dataIndex = item.dataIndex;
        const columns = JSON.parse(JSON.stringify(datas.newColumns));
        const columnIndex = datas.newColumns.findIndex(
          (item) => item.dataIndex == dataIndex
        );
        if (type == "up") {
          if (index <= 0) return;
          console.log("item", item);
          const checkboxColumn1 = datas.checkboxColumns[index - 1];
          const checkboxColumn2 = datas.checkboxColumns[index];
          datas.checkboxColumns[index - 1] = checkboxColumn2;
          datas.checkboxColumns[index] = checkboxColumn1;

          if (columnIndex >= 0) {
            const newColumn1 = datas.newColumns[columnIndex - 1];
            const newColumn2 = datas.newColumns[columnIndex];
            columns[columnIndex - 1] = newColumn2;
            columns[columnIndex] = newColumn1;
          }
        } else {
          if (index >= datas.checkboxColumns.length - 1) return;
          const checkboxColumn1 = datas.checkboxColumns[index];
          const checkboxColumn2 = datas.checkboxColumns[index + 1];
          datas.checkboxColumns[index] = checkboxColumn2;
          datas.checkboxColumns[index + 1] = checkboxColumn1;

          if (columnIndex >= 0) {
            const newColumn1 = datas.newColumns[columnIndex];
            const newColumn2 = datas.newColumns[columnIndex + 1];
            columns[columnIndex] = newColumn2;
            columns[columnIndex + 1] = newColumn1;
          }
        }

        datas.newColumns = [];
        setTimeout(() => {
          datas.newColumns = columns;
        })

        let columnsSetUpSetting = JSON.parse(
          localStorage.getItem("columnsSetUpSetting")
        );
        if (!columnsSetUpSetting) columnsSetUpSetting = {};
        columnsSetUpSetting[`${currentPath}-${props.tableId}`] =
          datas.checkboxColumns;
        localStorage.setItem(
          "columnsSetUpSetting",
          JSON.stringify(columnsSetUpSetting)
        );
      },
      // 批量设置table的列顺序
      bathColumnOrderBy() {
        let columnsSetUpSetting = JSON.parse(
          localStorage.getItem("columnsSetUpSetting")
        );
        if (columnsSetUpSetting) {
          const checkboxColumns =
            columnsSetUpSetting[`${currentPath}-${props.tableId}`];
          columnSetupMethods.toColumnOrderBy(checkboxColumns);
        }
      },
      toColumnOrderBy(checkboxColumns) {
        const columns = JSON.parse(JSON.stringify(props.columns));
        if (checkboxColumns != null && checkboxColumns.length > 0) {
          let newColumns = [];
          const filterCheckeds = checkboxColumns.filter(
            (item) => item.checked
          );
          filterCheckeds.forEach((item, index) => {
            const column = columns.find((f) => f.dataIndex == item.dataIndex);
            if (column != null) {
              newColumns.push(column);
            }
          });
          datas.newColumns = newColumns;
        }
      },

      // 列设置拖拽结束事件
      onEnd() {
        datas.newColumns = [];
        setTimeout(() => {
          columnSetupMethods.toColumnOrderBy(datas.checkboxColumns);
        });
      },
      saveColumnSetting() {
        let columnsSetting = JSON.parse(localStorage.getItem("columnsSetting"));
        if (!columnsSetting) columnsSetting = {};
        let checkedColumns = [];
        datas.checkboxColumns.forEach((item) => {
          if (!item.checked) {
            checkedColumns.push(item);
          }
        });
        columnsSetting[`${currentPath}-${props.tableId}`] = checkedColumns;
        localStorage.setItem("columnsSetting", JSON.stringify(columnsSetting));
        let columnsSetUpSetting = JSON.parse(
          localStorage.getItem("columnsSetUpSetting")
        );
        if (!columnsSetUpSetting) columnsSetUpSetting = {};
        columnsSetUpSetting[`${currentPath}-${props.tableId}`] =
          datas.checkboxColumns;
        localStorage.setItem(
          "columnsSetUpSetting",
          JSON.stringify(columnsSetUpSetting)
        );
        proxy.$modal.msgSuccess("保存列设置成功");
      },
      restColumnSetting() {
        let columnsSetting = JSON.parse(localStorage.getItem("columnsSetting"));
        if (columnsSetting) {
          delete columnsSetting[`${currentPath}-${props.tableId}`]
          localStorage.setItem(
            "columnsSetting",
            JSON.stringify(columnsSetting)
          );
        }
        // 排序
        let columnsSetUpSetting = JSON.parse(
          localStorage.getItem("columnsSetUpSetting")
        );
        if (columnsSetUpSetting) {
          delete columnsSetUpSetting[`${currentPath}-${props.tableId}`]
          localStorage.setItem(
            "columnsSetUpSetting",
            JSON.stringify(columnsSetUpSetting)
          );
        }
        datas.newColumns = [];
        setTimeout(() => {
          columnSetupMethods.initCheckboxColumns();
          proxy.$modal.msgSuccess("重置列设置成功");
        })
      }
    };

    // 对外工具方法
    const toolsMethdos = {
      setQueryWhereItem(key, value) {
        datas.queryWhere[key] = value;
      },
      setDataSource(data) {
        datas.newDataSource = data;
      },
      // 设置往列表中添加数据 添加类型:type: push 追加 unshift添加到第一行
      setAddDataSource(data, type) {
        if (type == "unshift") {
          datas.newDataSource.unshift(data);
        } else if (type == "push") {
          datas.newDataSource.push(data);
        }
      },
      getSelectionRows() {
        const rows = tableRef.value.getSelectionRows();
        return rows;
      }
    };

    return {
      domId,
      slots,
      tableRef,
      ...toRefs(datas),
      ...methods,
      ...toolsMethdos,
      ...columnSetupMethods,
    };
  },
};
</script>

<style lang="scss" scoped>
.full {
  background-color: #fff;
  padding-top: 20px !important;
}

/** 设置隐藏列,卡片样式 */
:global(.overlayStyle) {
  width: auto !important;
  height: 50% !important;
}

.Column-setup {
  width: 100%;
  height: 95%;
  display: flex;
  flex-flow: column;
  overflow-y: auto;
  overflow-x: hidden;
  flex-wrap: nowrap;
  padding-right: 10px;
}

.setup-item {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .operate-box {
    display: flex;
  }
}

.search {
  min-width: 50%;
  width: 100%;
  padding-left: -10px;

  .search-top-box {
    display: flex;
    justify-content: space-between;
    padding-right: 0px;
    align-items: center;
    flex-wrap: nowrap;
    padding-bottom: 5px;
  }

  .search-box {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
  }
}

.search-bottom-item {
  margin-bottom: 5px;
}

::v-deep(.el-table__cell) {
  position: static !important; // 解决el-image 和 el-table冲突层级冲突问题
}

.pagination-box {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}
</style>
